import { c as _c } from "react-compiler-runtime";
import styled, { css } from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { URANUS_LAYER } from 'foundations-components/transitional/constants';
import CommentModeCursorTooltip from './CommentModeCursorTooltip';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CommentModeIndicatorSharedStyle = css(["position:fixed;background-color:", ";overflow:hidden;z-index:", ";"], ({
  theme
}) => theme.color['fill-brand-default'], URANUS_LAYER);
const TopIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__TopIndicator"
})(["", " height:", ";width:100%;top:0;left:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const BottomIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__BottomIndicator"
})(["", " height:", ";width:100%;bottom:0;left:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const LeftIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__LeftIndicator"
})(["", " height:100%;width:", ";left:0;top:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const RightIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__RightIndicator"
})(["", " height:100%;width:", ";right:0;top:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const ModeIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__ModeIndicator"
})(["", " right:0;top:0;border-bottom-left-radius:18px;"], CommentModeIndicatorSharedStyle);
function CommentModeIndicator(t0) {
  "use memo";

  const $ = _c(11);
  const {
    onCancel
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(TopIndicator, {
      className: "top-indicator"
    });
    t2 = /*#__PURE__*/_jsx(BottomIndicator, {
      className: "bottom-indicator"
    });
    t3 = /*#__PURE__*/_jsx(LeftIndicator, {
      className: "left-indicator"
    });
    t4 = /*#__PURE__*/_jsx(RightIndicator, {
      className: "right-indicator"
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx(H5, {
      color: "text-core-on-fill-default",
      marginBlockStart: "600",
      marginInlineEnd: "1300",
      marginBlockEnd: "500",
      marginInlineStart: "700",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "collaborationSidebar.modals.commentMode.title"
      })
    });
    t6 = /*#__PURE__*/_jsx(CloseButton, {
      size: "medium",
      color: "icon-interactive-on-fill-default",
      marginBlockStart: "100",
      marginInlineEnd: "100"
    });
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onCancel) {
    t7 = /*#__PURE__*/_jsx(ModeIndicator, {
      className: "comment-mode--indicator-button",
      "data-test-id": "comment-mode-indicator",
      children: /*#__PURE__*/_jsxs(Button, {
        onClick: onCancel,
        use: "unstyled",
        children: [t5, t6]
      })
    });
    $[6] = onCancel;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx(CommentModeCursorTooltip, {
      portalClassnameWrapper: "comment-mode-cursor-tooltip"
    });
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t1, t2, t3, t4, t7, t8]
    });
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}
CommentModeIndicator.propTypes = {
  onCancel: PropTypes.func.isRequired
};
export default CommentModeIndicator;